import { Routes } from '@angular/router';
import { MailLinksComponent } from './mail-links.component';

export const mailLinksRoutes: Routes = [
    {
        path: 'mail-links',
        component: MailLinksComponent
    }
];
